/**
 * Storage abstraction layer that works in both browser and Chrome extension contexts
 */

// Check if we're running in a Chrome extension context
const isExtension = !!(window.chrome && chrome.runtime && chrome.runtime.id);

/**
 * Gets an item from storage
 */
export const getItem = async (key: string): Promise<string | null> => {
  if (isExtension) {
    return new Promise((resolve) => {
      chrome.storage.local.get([key], (result) => {
        resolve(result[key] || null);
      });
    });
  } else {
    return localStorage.getItem(key);
  }
};

/**
 * Sets an item in storage
 */
export const setItem = async (key: string, value: string): Promise<void> => {
  if (isExtension) {
    return new Promise((resolve) => {
      chrome.storage.local.set({ [key]: value }, () => {
        resolve();
      });
    });
  } else {
    localStorage.setItem(key, value);
  }
};

/**
 * Removes an item from storage
 */
export const removeItem = async (key: string): Promise<void> => {
  if (isExtension) {
    return new Promise((resolve) => {
      chrome.storage.local.remove(key, () => {
        resolve();
      });
    });
  } else {
    localStorage.removeItem(key);
  }
};

/**
 * Clears all storage
 */
export const clear = async (): Promise<void> => {
  if (isExtension) {
    return new Promise((resolve) => {
      chrome.storage.local.clear(() => {
        resolve();
      });
    });
  } else {
    localStorage.clear();
  }
};

export default {
  getItem,
  setItem,
  removeItem,
  clear
}; 